import {CanActivate, Router} from '@angular/router';
import {Injectable} from '@angular/core';
import {AuthService} from '../../auth.service';

@Injectable()
export class HomeGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {
  }

  canActivate() {
    if (this.authService.isAuthenticated()) {
      if (this.authService.isPractitioner()) {
        this.router.navigate(['/process-clauses']);
      } else if (this.authService.isSpecialist()) {
        this.router.navigate(['/projects']);
      } else if (this.authService.isCoordinator()) {
        this.router.navigate(['/ecv']);
      } else if (this.authService.isClient()) {
        this.router.navigate(['/client']);
      } else if (this.authService.isAdmin()) {
        this.router.navigate(['/dict-panel']);
      }
      return true;
    }
    this.authService.setRedirectUrl();
    this.router.navigate(['/login']);
    return false;
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/core/guards/services/home-guard.service.ts